import React from 'react'

export default function Invoices() {
    return (
        <div>Счет на оплату</div>
    )
}
